import { Component } from "react";
import { Link } from "react-router-dom";

import { Container, Row, Col } from "react-bootstrap";
import { FooterLogo } from "./MultipleComp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FRONT_BASE_URL, FILE_BASE_URL } from "./App";

import {
  faTwitter,
  faFacebookF,
  faInstagram,
  faYoutube,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import $ from "jquery";
import { t } from "i18next";
import RightSideButton from "./RightSideButton";

export default class Footer extends Component {
  constructor() {
    super();
    this.state = {
      showHide: false,
    };
  }

  toggleList = () => {
    if (window.innerWidth > 767) {
      this.setState((prevState) => ({
        isOpen: !prevState.isOpen,
      }));
    }
  };
  openList = () => {
    if (window.innerWidth > 767) {
      this.setState({ isOpen: true });
    }
  };

  closeList = () => {
    if (window.innerWidth > 767) {
      this.setState({ isOpen: false });
    }
  };


  componentDidMount() {
    // console.log("current urllllllllllllllll",window.location.href.includes("landing"))

    var Wwidth = $(window).width();
    if (Wwidth < 768) {
      $(".footer-container").hide();
      $(".footer-title.active").addClass("active").next().show();
      $(".footer-title").click(function () {
        $(this)
          .toggleClass("active")
          .parent()
          .find(".footer-container")
          .slideToggle("fast");
        return false;
      });
    }
  }

  render() {
    const { isOpen } = this.state;
    const link = window.location.href.includes('landing/applynow');
    return (
      <>
        <RightSideButton />
        <footer id="footer" className="footer">
          <Container>
            <Row>
              <Col lg={3}>
                <div className="footer-widget">
                  <figure className="mb-4">
                    <FooterLogo />
                  </figure>
                  <p>
                    {t(
                      "Hero Housing Finance Ltd. is a fully-owned subsidiary of Hero FinCorp, the best-in-class provider of financing solutions. Hero Housing Finance Limited is an all-inclusive housing finance company providing hassle-free home loans across India."
                    )}
                  </p>
                </div>
              </Col>
              <Col lg={{ span: 8, offset: 1 }}>
                <Row>
                  <Col md={4}>
                    <div className="footer-widget">
                      <h5 className="footer-title">{t("Housing Loans")}</h5>
                      <div className="footer-container">
                        <ul>
                          <li>
                            <Link to="/housing-loans/home-loan-rate-of-interest">
                              {t("Purchase of New Property")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/housing-loans/home-loan-balance-transfer">
                              {t("Balance Transfer")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/housing-loans/home-construction-loan">
                              {t("Self Construction")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/housing-loans/plot-loan">
                              {t("Plot Purchase (Development Authority)")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/housing-loans/home-renovation-loan">
                              {t("Renovation | Extension")}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="footer-widget">
                      <h5 className="footer-title">{t("Non-Housing Loans")}</h5>
                      <div className="footer-container">
                        <ul>
                          <li>
                            <Link to="/non-housing-loans/lap-loan">
                              {t(
                                "Loan Against Property on Built up Residential Property"
                              )}
                            </Link>
                          </li>
                          <li>
                            <Link to="/non-housing-loans/loan-against-commercial-property">
                              {t(
                                "Loan Against Property on Commercial Property"
                              )}
                            </Link>
                          </li>
                          <li>
                            <Link to="/non-housing-loans/mixed-used-property-loan">
                              {t("Loan Against Property on Mixed use Property")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/non-housing-loans/commercial-property-loan">
                              {t("Commercial Property Purchase")}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="footer-widget">
                      <h5 className="footer-title">{t("Quick Links")}</h5>
                      <div className="footer-container">
                        <ul>
                          <li>
                            <Link to="/about-us">{t("about_us")}</Link>
                          </li>
                          <li>
                            <Link to="/careers">{t("careers")}</Link>
                          </li>
                          <li>
                            <a
                              onClick={() => {
                                window.open(
                                  `${FILE_BASE_URL}/uploads/Customer_Complaint_Escalation_Flowchart.png`
                                );
                              }}
                              href="#"
                            >
                              {t("Complaints")}
                            </a>
                          </li>

                          <li>
                            <Link to="/instant-loan-approval/1">
                              {t("Instant Loan Approval")}
                            </Link>
                          </li>

                          <li>
                            <Link to="/policies-and-codes">
                              {t("policies_and_codes")}
                            </Link>
                          </li>

                          <li>
                            <Link to="/contact-us">{t("Reach Out to Us")}</Link>
                          </li>
                          <li>
                            <Link to="/blog">{t("Blog")}</Link>
                          </li>
                          <li>
                            <a
                              rel="noreferrer"
                              href=" https://smartodr.in/login"
                              target="_blank"
                            >
                              {t("Link to Smart ODR")}
                            </a>
                          </li>

                          <li>
                            <a
                              onClick={() => {
                                window.open(
                                  `${FILE_BASE_URL}/uploads/pdf/sebi-odr-circulars-dated-28-december-2023.pdf`
                                );
                              }}
                              href="#"
                            >
                              {t("SEBI Circular on Online Dispute Resolution")}
                            </a>
                          </li>

                          <a rel="noreferrer" href="/landing/enquiry-referals">
                            {t("Dealership QR code")}
                          </a>
                          <li>
                            <a
                              rel="noreferrer"
                              href="https://www.herofincorp.com/products"
                              target="_blank"
                            >
                              {t("Hero FinCorp")}
                            </a>
                          </li>
                          <li>
                            <div className={`footer-widget ${isOpen ? "open" : ""}`}
                              onMouseEnter={this.openList}
                              onMouseLeave={this.closeList}>
                              <p className="footer-title insurance-title active insurance-dropdown"

                                onClick={this.toggleList}
                                style={{ cursor: "pointer" }}>{t("Insurance")}</p>
                              {isOpen ? (

                                <div className="footer-container">
                                  <ul>
                                    <li>
                                      <a href="https://www.icicilombard.com" target="_blank">{t("ICICI Lombard General Insurance Company Limited")}</a>
                                    </li>
                                    <li>
                                      <a href="https://www.tataaig.com" target="_blank">
                                        {t("Tata AIG General Insurance Company Limited")}
                                      </a>
                                    </li>
                                    <li>
                                      <a href=" https://www.iciciprulife.com" target="_blank">
                                        {t("ICICI Prudential Life Insurance Company Limited")}
                                      </a>
                                    </li>
                                    <li>
                                      <a href="https://www.hdfclife.com/" target="_blank">
                                        {t("HDFC Life Insurance Company Limited")}
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              ) : (
                                window.innerWidth < 767 && (
                                  <div className="footer-container insurance-tab">
                                    <ul>
                                      <li>
                                        <a href="https://www.icicilombard.com" target="_blank">{t("ICICI Lombard General Insurance Company Limited")}</a>
                                      </li>
                                      <li>
                                        <a href="https://www.tataaig.com" target="_blank">
                                          {t("Tata AIG General Insurance Company Limited")}
                                        </a>
                                      </li>
                                      <li>
                                        <a href=" https://www.iciciprulife.com" target="_blank">
                                          {t("ICICI Prudential Life Insurance Company Limited")}
                                        </a>
                                      </li>
                                      <li>
                                        <a href="https://www.hdfclife.com/" target="_blank">
                                          {t("HDFC Life Insurance Company Limited")}
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                ))}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                  </Col>
                </Row>
              </Col>
            </Row>

            <div className="disclaimer-sec mt-5 mb-5">
              <p>{t("IRDAI License No: CA1003")}</p>
              <p>{t("Validity of current license 05-Dec-2024  to 04-Dec-2027, category of license : Corporate Agent (Composite)")}</p>
            </div>

            <div className="disclaimer-sec mt-5 mb-5">
              <p>{t("Disclaimer")}</p>
            </div>

            {link ? <div className="disclaimer-sec mt-5 mb-5 border-top-dotted pt-3" >
              <p>{t("Disclaimer for ATS")}</p>
            </div> : ''}

            <div className="copyright-sec">
              <Row className="align-items-center">
                <Col md={12} lg={8}>
                  <p className="m-0">
                    {t("Toll-free")}:{" "}
                    <a href="tel:1800-212-8800">1800-212-8800</a> |{" "}
                    {t("E-mail")}:{" "}
                    <a href="mailto:customer.care@herohfl.com">
                      customer.care@herohfl.com
                    </a>{" "}
                    | {t("Website")}:{" "}
                    <a href="https://www.herohousingfinance.com/">
                      www.herohousingfinance.com
                    </a>
                  </p>
                </Col>
                <Col md={12} lg={4}>
                  <div className="social-links">
                    <ul>
                      <li>
                        <a
                          rel="noreferrer"
                          href="https://twitter.com/HeroHFL"
                          target="_blank"
                          aria-label="twitter"
                        >
                          <FontAwesomeIcon icon={faTwitter} />
                        </a>
                      </li>
                      <li>
                        <a
                          aria-label="facebook"
                          rel="noreferrer"
                          href="https://www.facebook.com/herohousingfinance/"
                          target="_blank"
                        >
                          <FontAwesomeIcon icon={faFacebookF} />
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noreferrer"
                          href="https://www.instagram.com/herohousingfinance/?utm_medium=copy_link"
                          target="_blank"
                          aria-label="instagram"
                        >
                          <FontAwesomeIcon icon={faInstagram} />
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noreferrer"
                          href="https://www.youtube.com/channel/UChUCVOaHM5unlCKNmKFb_7Q"
                          target="_blank"
                          aria-label="youtube"
                        >
                          <FontAwesomeIcon icon={faYoutube} />
                        </a>
                      </li>
                      <li>
                        <a
                          rel="noreferrer"
                          href="https://www.linkedin.com/company/herohousingfinance/"
                          target="_blank"
                          aria-label="linkedin"
                        >
                          <FontAwesomeIcon icon={faLinkedinIn} />
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="footer-link">
                    <div className="footer-widget">
                      <ul>
                        <li>
                          <Link to="/sitemap">{t("Sitemap")}</Link>
                        </li>
                        <li>
                          <Link to="/privacy-policy">
                            {t("Privacy Policy")}
                          </Link>
                        </li>

                        {/* <li>
                              <a
                                onClick={() => {
                                  window.open(
                                    `${FILE_BASE_URL}/uploads/pdf/mitcs-november.pdf`
                                  );
                                }}
                                href="#"
                              >
                                {t("MITC(Most Important Terms and Conditions)")}
                              </a>
                            </li> */}
                      </ul>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </footer>
      </>
    );
  }
}
